const imageValidator = (filename, file) => {
    const size = file.size;
    const fileTypes = ["jpg","png","jpeg"]
    const lastDot = filename.lastIndexOf('.')
    const ext = filename.substring(lastDot + 1)
    const valid = fileTypes.includes(ext)
    const sizeValid = parseInt(size) > 3145728

    return {
        extValid: valid,
        ext: ext,
        sizeValid: !sizeValid
    }
}

export default imageValidator

